const renderRaffleDeadline = ($) => {
	if(!$(".js-raffle-deadline-date").length) return;
	$(".js-raffle-deadline-date").each(function () {
		var day = $(this).data().day;
		$(this).html(day);
	});
};

export default renderRaffleDeadline;
